import * as actionTypes from "../constants/reducer";
const initialState={
   forum_selection:[],
   forum_filter:{
       home:[],
       channels:[],
       kursusQu:[]
   },
   trending:[],
   beranda:null,
   forum_list:[],
   search_list:[],
   forum_detail:null,
   post_diskusi:{
        Id:0,
        ForumId:0,
        ParentId:0,
        Title:'',
        Text:'',
        Tags:[],
        Files:null,
        File_url:'',
        extension:''
   },
   search:'',
   filter_search:0
}
const  reducer= (state=initialState,action)=>{
    switch (action.type) {
        case actionTypes.SET_REDUCER:
            return{
                ...state,
                [Object.keys(action.payload)]:Object.values(action.payload)[0]
            }
    case actionTypes.SET_FORUM_LIST:
            return{
                ...state,
                forum_list:[...state.forum_list,...action.payload]
            }
        default:
            return state;
    }
}

export default reducer